import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email.trim(), password.trim());
            if (u.role !== "admin") { toast.error("Not an admin account"); setLoading(false); return; }
            nav("/admin");
        } catch (e) { toast.error(e.response?.data?.detail || "Login failed"); setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-neutral-100 p-4" data-testid="admin-login-page">
            <form onSubmit={submit} className="w-full max-w-[400px] bg-white border-2 border-black p-8 brutal-shadow">
                <div className="font-mono text-[10px] uppercase text-neutral-500">Clonzo</div>
                <h1 className="font-display text-4xl tracking-tighter mt-1">Admin Login</h1>
                <div className="mt-6 space-y-4">
                    <label className="block">
                        <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Email</div>
                        <input required type="email" autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={email} onChange={e => setEmail(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="admin-email" />
                    </label>
                    <label className="block">
                        <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Password</div>
                        <input required type="password" autoComplete="current-password" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={password} onChange={e => setPassword(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="admin-password" />
                    </label>
                    <button disabled={loading} type="submit" className="w-full bg-black text-white py-3 font-mono uppercase text-xs tracking-widest" data-testid="admin-login-submit">{loading ? "…" : "Login"}</button>
                </div>
            </form>
        </div>
    );
}
